import { render, staticRenderFns } from "./ProfessionCreate.vue?vue&type=template&id=06011747"
import script from "./ProfessionCreate.vue?vue&type=script&lang=js"
export * from "./ProfessionCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports